import { render, staticRenderFns } from "./PostJob.vue?vue&type=template&id=5aa51818&"
import script from "./PostJob.vue?vue&type=script&lang=js&"
export * from "./PostJob.vue?vue&type=script&lang=js&"
import style0 from "./PostJob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports